const FACILITY_ACRONYMS = new Map<string, string>([
  ["avenal", "ASP"],
  ["calipatria", "CAL"],
  ["ccwf-chowchilla", "CCWF"],
  ["cci-tehachapi", "CCI"],
  ["centinela", "CEN"],
  ["chcf-stockton", "CHCF"],
  ["cim-chino", "CIM"],
  ["ciw-corona", "CIW"],
  ["cmc-san-luis-obispo", "CMC"],
  ["cmf-vacaville", "CMF"],
  ["crc-norco", "CRC"],
  ["csp-corcoran", "COR"],
  ["csp-sacramento", "CSP-SAC"],
  ["csp-sac", "CSP-SAC"],
  ["csp-solano", "SOL"],
  ["ctf-soledad", "CTF"],
  ["cvsp-blythe", "CVSP"],
  ["folsom", "FSP"],
  ["hdsp-susanville", "HDSP"],
  ["ironwood-blythe", "ISP"],
  ["kvsp-delano", "KVSP"],
  ["lac-lancaster", "LAC"],
  ["mule-creek", "MCSP"],
  ["nksp-delano", "NKSP"],
  ["pbsp-crescent-city", "PBSP"],
  ["pvsp-coalinga", "PVSP"],
  ["rjd-donovan", "RJD"],
  ["satf-corcoran", "SATF"],
  ["scc-jamestown", "SCC"],
  ["sq-san-quentin", "SQ"],
  ["svsp-soledad", "SVSP"],
  ["vsp-chowchilla", "VSP"],
  ["wasco", "WSP"],
]);

const ACRONYM_STOP_WORDS = new Set(["the", "of", "for", "and"]);

export function facilityAcronym(
  code: string | null | undefined,
  label: string | null | undefined,
): string {
  const normalizedCode = code?.trim().toLowerCase();
  if (normalizedCode && FACILITY_ACRONYMS.has(normalizedCode)) {
    return FACILITY_ACRONYMS.get(normalizedCode) as string;
  }

  if (normalizedCode) {
    const firstPart = normalizedCode.split("-").find(Boolean);
    if (firstPart && firstPart.length <= 5) {
      return firstPart.toUpperCase();
    }
  }

  const words = (label ?? "")
    .replace(/,/g, " ")
    .split(/\s+/)
    .filter((word) => word && !ACRONYM_STOP_WORDS.has(word.toLowerCase()));

  return words.length > 0
    ? words.map((word) => word.charAt(0).toUpperCase()).join("")
    : "-";
}
